import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/AdminFetchMyCompanies';

export const FETCH_MY_COMPANIES = defineAsyncActionTypes(`${prefix}/FETCH_MY_COMPANIES`);



// WEBPACK FOOTER //
// ./src/store/graphql/AdminFetchMyCompanies/action-types.js